import { DEFAULT_CURRENCY_LOCALE } from "@zenith/data/constants";

/**
 * Gets the compact suffixed number, as a string.
 * @function
 * @name getSuffixedNumber
 * @kind function
 * @param {number=} num The original number.
 * @param {number=} maximumFractionDigits The Maximum Fraction Digits (`2` by default).
 * @param {number=} minimumFractionDigits The Minimum Fraction Digits (`2` by default).
 * @returns {string} The compact suffixed number.
 * @exports
 */
export function getSuffixedNumber(
  num?: number,
  maximumFractionDigits: number | undefined = 2,
  minimumFractionDigits: number | undefined = 2
): string {
  if (num === undefined) return "";
  const formatter = new Intl.NumberFormat(DEFAULT_CURRENCY_LOCALE, {
    maximumFractionDigits,
    minimumFractionDigits,
    notation: "compact",
  });

  return formatter.format(num);
}
